import React from "react";
import planning from "../../Assets/Projects/planning.gif";
import "./ProjectsTitle.css";

const ProjectsTitle = () => {
  return (
    <div className='projectTitleContainer container'>
      <div className='title'>Projects</div>
      <div className='imageContainer'>
        <img src={planning} width={260} height={195} alt="planning" />
      </div>
    </div>
  );
};

export default ProjectsTitle;
